import { render, staticRenderFns } from "./CardServiciosComponent.vue?vue&type=template&id=1a35d8da"
import script from "./CardServiciosComponent.vue?vue&type=script&lang=js"
export * from "./CardServiciosComponent.vue?vue&type=script&lang=js"
import style0 from "./CardServiciosComponent.vue?vue&type=style&index=0&id=1a35d8da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports